<template>
  <div v-if="user == 0 && (owner === 'drr')">
    <b-row class="match-height">
      <!-- frame Top 5 สายทางที่มีปริมาณจราจรต่อชั่วโมงมากที่สุด -->
      <b-col
        xl="6"
        lg="6"
        md="6"
        sm="12"
        xs="12"
      >
        <b-card style="background-color: rgb(255, 127, 96, 0.0); width: 100%; height: auto; border: 2px solid #00B058; border-radius: 40px 4px 40px 4px;">
          <div>
            <b-img
              class="mr-1 mb-1"
              height="25"
              src="@/assets/images/iconsDB/icontime.svg"
            />
            <span style="font-size:20px; color: #fff; font-weight: 600;">Top 5 สายทางที่มีปริมาณจราจรต่อชั่วโมงมากที่สุด</span>
          </div>
          <div>
            <b-row
              v-for="(itemT, indexT) in progressT.slice(0, 5)"
              :key="indexT"
              style="margin-top: 35px;"
            >
              <b-col
                lg="9"
              >
                <b-link to="/">
                  <label style="color: #ffffff; font-size: 18px; width: 110%;">{{ indexT+1 +'. ' }} {{ itemT.WayID }}</label>
                </b-link>
                <b-progress
                  :value="itemT.Total_PCU"
                  :max="progressT[0].Total_PCU + 50"
                  precision="2"
                  :class="colorprogressT[indexT]"
                />
              </b-col>
              <b-col
                lg="3"
                style="text-align: center;"
              >
                <span style="color:#ffffff; font-size: 17px;">{{ itemT.Total_PCU.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }} PCU/ชม.</span>
              </b-col>
            </b-row>
          </div>
        </b-card>
      </b-col>

      <!-- frame สถิติการตรวจสอบเหตุการณ์ที่อาจจะเกิดอุบัติเหตุภายใน 7 วัน (Analytic) -->
      <b-col
        xl="6"
        lg="6"
        md="6"
        sm="12"
        xs="12"
      >
        <b-card style="background-color: rgb(255, 127, 96, 0.0); width: 100%; height: 100%; border: 2px solid #00B058; border-radius: 40px 4px 40px 4px;">
          <div>
            <b-img
              class="mr-1 mb-1"
              height="25"
              src="@/assets/images/icons/gred.svg"
            />
            <span style="font-size:20px; color: #fff; font-weight: 600;">สถิติการตรวจสอบเหตุการณ์ที่อาจจะเกิดอุบัติเหตุภายใน 7 วัน (Analytic)</span>
          </div>

          <div>
            <app-echar-line
              :option-data="option"
            />
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow, BCol, BProgress, BImg, BLink, BCard,
} from 'bootstrap-vue'
import axios from '@axios'
import AppEcharLine from '@/views/dashboard/garaphLineDB/AppEchartLineDB.vue'

export default {
  components: {
    BRow,
    BCol,
    BProgress,
    BImg,
    BLink,
    BCard,
    AppEcharLine,
  },
  data() {
    return {
      statisticTitle: '',
      Total: '',
      user: '',
      owner: '',
      progressT: [],
      colorprogressT: [
        'progress1', 'progress2', 'progress3', 'progress4', 'progress5',
      ],
      option: {
        xAxisData: [],
        series: [
          {
            name: 'รถย้อนศร',
            type: 'line',
            areaStyle: {
              color: '#FF805D',
            },
            color: '#FF805D',
            showSymbol: false,
            smooth: 0.4,
            lineStyle: {
              width: 0,
            },
            data: [],
          },
          {
            name: 'รถหยุด',
            type: 'line',
            areaStyle: {
              color: '#FDFF01',
            },
            color: '#FDFF01',
            showSymbol: false,
            smooth: 0.4,
            lineStyle: {
              width: 0,
            },
            data: [],
          },
        ],
      },
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  created() {
    setInterval(this.getNow, 1000)
    this.interval = setInterval(() => {
      this.getPieCountingDB()
    }, 300000)
  },
  mounted() {
    this.user = this.userData.department
    this.owner = this.userData.groupname
    this.getPieCountingDB()
    this.getbarChartCounting()
  },
  methods: {
    // ด้านซ้าย 5 Top ประเภทยานพาหนะการจราจร
    getPieCountingDB() {
      axios
        .post('/getTop5VKTDB', { department: this.userData.department, owner: this.userData.groupname, username: this.userData.username })
        .then(response => {
          this.progressT = response.data
          console.log(this.user)
        })
        .catch(error => {
          console.log(error)
        })
    },
    for() {
      setTimeout(() => this.progressT.slice(0, 5).forEach((value, i) => {
        this.stream(value, i)
      }), 1000)
    },

    // ด้านขวา สถิติการตรวจสอบเหตุการณ์ที่อาจจะเกิดอุบัติเหตุภายใน 7 วัน (Analytic)
    getbarChartCounting() {
      axios
        .post('/getGraphAnalyticDB', { department: this.userData.department, owner: this.userData.groupname, username: this.userData.username })
        .then(response => {
          this.xAxisData = []
          this.xAxisData[0] = response.data
          this.xAxisData[0][0].forEach(value => {
            if (response.data[0].length >= 5) {
              this.option.xAxisData.push(value.Date_Name)
            }
            this.option.series[0].data.push(value.Wrong_Way)
          })
          this.xAxisData[0][1].forEach(value => {
            this.option.series[1].data.push(value.Car_Stop)
          })
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
}
</script>

<style lang="scss">
  .text1 {
    position: absolute;
    font-family: Arial;
    top: 20px;
    right: 20px;
    color: white;
  }
.progress1 .progress-bar{background: #579BFE;}
.progress2 .progress-bar{background: #DC48FF;}
.progress3 .progress-bar{background: #8246FE;}
.progress4 .progress-bar{background: #FE447A;}
.progress5 .progress-bar{background: #4EAF51;}
.progress6 .progress-bar{background: #FF805D;}
.progress7 .progress-bar{background: #FDFF01;}

  </style>
